import { useParams } from "react-router";

import {
  usePortfolio,
  usePortfolioCollection,
  useProducts,
  useWrapperTypes,
} from "@/lib/hooks/use-portfolio-collections";

import { PortfolioEditorSkeleton } from "../../skeleton-loaders";
import { PortfolioProductsEditor } from "./portfolio-products-editor";

export default function PortfolioProductsPage() {
  const { id, portfolioId } = useParams<{ id: string; portfolioId: string }>();
  const { portfolio, isLoading } = usePortfolio(id!, portfolioId!);
  const { products } = useProducts(id!);
  const { collection } = usePortfolioCollection(id!);
  const wrapperTypesEnabled = !!collection?.wrapperTypesEnabled;
  // Query is disabled while the feature is off — no wasted request.
  const { wrapperTypes } = useWrapperTypes(wrapperTypesEnabled ? id! : null);

  if (isLoading || !portfolio) {
    return <PortfolioEditorSkeleton />;
  }

  return (
    <PortfolioProductsEditor
      portfolio={portfolio}
      products={products}
      collectionId={id!}
      wrapperTypes={wrapperTypesEnabled ? wrapperTypes : []}
    />
  );
}
